





















































import { Component, Vue } from 'vue-property-decorator'
@Component({
  name: 'Page404'
})
export default class Page404 extends Vue {
  public message: string = '404 Page Not Found'
}
